module.exports = __webpack_public_path__ + "img/hr-sand-rock-small-05.4aef4a41.png";